import axios from '../../../../shared/axios';
import { AppDispatch } from '../../../../store';
import * as actionTypes from '../constants/actionTypes';
import { validateObj } from '../../../../shared/utils';

import {
  SystemMessageType,
  SystemMessage,
  KeyValuePair,
  SaveSystemMessageRequest,
  SaveSystemMessageImageRequest
} from '../../../../shared/models';

const getSystemMessageTypesStart = () => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_GET_SYSTEM_MESSAGES_TYPES_START,
  };
};

const getSystemMessageTypesSuccess = (data: SystemMessageType[]) => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_GET_SYSTEM_MESSAGES_TYPES_SUCCESS,
    data,
  };
};

const getSystemMessageTypesFail = (error: any) => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_GET_SYSTEM_MESSAGES_TYPES_FAIL,
    error,
  };
};

export const getSystemMessageTypes = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<SystemMessageType[]>((resolve, reject) => {
      dispatch(getSystemMessageTypesStart());
      axios
        .get(`/system-message/get-system-messages-types`)
        .then((response) => {
          dispatch(getSystemMessageTypesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getSystemMessageTypesFail(err));
          reject(err);
        });
    });
  };
};

const getDatabasesStart = () => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_GET_DATABASES_START,
  };
};

const getDatabasesSuccess = (data: KeyValuePair[]) => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_GET_DATABASES_SUCCESS,
    data,
  };
};

const getDatabasesFail = (error: any) => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_GET_DATABASES_FAIL,
    error,
  };
};

export const getDatabases = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<KeyValuePair[]>((resolve, reject) => {
      dispatch(getDatabasesStart());
      axios
        .get(`/system-message/get-databases`)
        .then((response) => {
          dispatch(getDatabasesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getDatabasesFail(err));
          reject(err);
        });
    });
  };
};

const getSystemMessageDataStart = () => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_GET_SYSTEM_MESSAGE_DATA_START,
  };
};

const getSystemMessageDataSuccess = (data: SystemMessage) => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_GET_SYSTEM_MESSAGE_DATA_SUCCESS,
    data,
  };
};

const getSystemMessageDataFail = (error: any) => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_GET_SYSTEM_MESSAGE_DATA_FAIL,
    error,
  };
};

export const getSystemMessageData = (params: { [key: string]: any }) => {
  return (dispatch: AppDispatch) => {
    return new Promise<SystemMessage>((resolve, reject) => {
      dispatch(getSystemMessageDataStart());
      axios
        .get(`/system-message/get-system-message-data`, { params: validateObj(params) })
        .then((response) => {
          dispatch(getSystemMessageDataSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getSystemMessageDataFail(err));
          reject(err);
        });
    });
  };
};

const saveSystemMessageStart = () => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_START,
  };
};

const saveSystemMessageSuccess = (data: boolean) => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_SUCCESS,
    data,
  };
};

const saveSystemMessageFail = (error: any) => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_FAIL,
    error,
  };
};

export const saveSystemMessage = (params: SaveSystemMessageRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(saveSystemMessageStart());
      axios
        .post(`/system-message/save-system-message`, validateObj(params))
        .then((response) => {
          dispatch(saveSystemMessageSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveSystemMessageFail(err));
          reject(err);
        });
    });
  };
};

const saveSystemMessageImageStart = () => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_IMAGE_START,
  };
};

const saveSystemMessageImageSuccess = (data: boolean) => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_IMAGE_SUCCESS,
    data,
  };
};

const saveSystemMessageImageFail = (error: any) => {
  return {
    type: actionTypes.SYSTEM_MESSAGES_SAVE_SYSTEM_MESSAGE_IMAGE_FAIL,
    error,
  };
};

export const saveSystemMessageImage = (params: SaveSystemMessageImageRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(saveSystemMessageImageStart());
      axios
        .post(`/system-message/save-system-message-image`, validateObj(params))
        .then((response) => {
          dispatch(saveSystemMessageImageSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveSystemMessageImageFail(err));
          reject(err);
        });
    });
  };
};
